import type { FocusArea } from '$lib/types';

export const focusAreas: FocusArea[] = [
	{
		title: 'Cloud & Infrastructure',
		description:
			'Azure and AWS platforms, high-availability design, and disaster recovery for mission-critical environments.'
	},
	{
		title: 'Identity & PKI',
		description:
			'Active Directory, Microsoft Entra, LDAP, and certificate infrastructure — domain and forest design, identity lifecycle, Group Policy, and hybrid operations that stay authenticated under real-world change.'
	},
	{
		title: 'Applications & Integration',
		description:
			'Full-stack web development, iOS applications, and API design across REST, GraphQL, and enterprise integration patterns.'
	},
	{
		title: 'Reliability & Automation',
		description:
			'Monitoring, PowerShell automation, CI/CD pipelines, and process improvements that reduce manual work and incident response time.'
	}
];
